import { j as t } from "./index.es44.js";
const c = ({
  headingLevel: a = 2,
  isGroupHeader: r = !1,
  ...e
}) => {
  const s = (() => {
    switch (a) {
      case 0:
        return r ? "h1" : "h2";
      case 2:
        return r ? "h2" : "h3";
      case 3:
        return r ? "h3" : "h4";
      case 4:
        return r ? "h4" : "h5";
      case 5:
        return r ? "h5" : "h6";
      default:
        return r ? "h2" : "h3";
    }
  })();
  return /* @__PURE__ */ t.jsx(
    s,
    {
      className: `bd-accordion-header__header-tag ${e.className}`,
      ...e,
      children: e.children
    }
  );
};
export {
  c as default
};
//# sourceMappingURL=index.es129.js.map
